export default __webpack_public_path__ + "static/media/ChampionsPlus_Nameplate_Customization.20eaf9d7.png";